import CircularProgress from '@mui/material/CircularProgress';
const Button = ({
  callback = null,
  children,
  testid = '',
  loading = false,
}) => {
  const buttonClass = `
    text-md 
    relative 
    min-w-[100%] 
    rounded-md 
    px-3 
    py-4 
    font-bold 
    uppercase 
    text-white 
    shadow 
    duration-300 
    sm:min-w-[200px]
    ${
      loading
        ? 'bg-primary-100'
        : 'bg-primary-700 hover:bg-primary-100 hover:text-black '
    }`;

  let disable;
  if (loading) disable = 'disabled';
  return (
    <button
      data-cy={testid}
      onClick={callback}
      className={buttonClass}
      disabled={loading}
    >
      {children}
      {loading && (
        <CircularProgress
          size={30}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      )}
    </button>
  );
};

export default Button;
